module.exports = __webpack_public_path__ + "static/media/suedtirolerjobs.fad07b8c.svg";